<template>
  <div>
    <CardBase>
      <MacroSubHeader
        title="Usuários do Sistema"
        icon="fas fa-users fa-1x"
      >
        <template slot="actions">
            <el-button
              v-if="isAuthorized"
              size="small" 
              type="primary"
              plain
              @click="regraGrupos"
            >
              <i class="fas fa-check-double"></i>
              Regras de Grupos
            </el-button>

            <el-button
              size="small" 
              plain
              @click="$refs.userCreateModal.toggleModal()"
            >
              <i class="fa fa-plus"></i>
              Novo Usuário
            </el-button>
        </template>
      </MacroSubHeader>

      <CardBase>
        <!-- Filtros -->
        <el-form label-position="top">
          <el-row 
            class="mb-3 bg-red" 
            type="flex" 
            :gutter="12" 
            align="bottom"
          >
            <!-- Usuario -->
            <el-col :span="5">
                <label>Nome</label>
                <el-input
                    v-model="filters.nome" 
                    size="small" 
                    placeholder="Filtrar pelo nome..."
                    @keyup.enter.native.prevent="fetch()"
                />
            </el-col>
  
            <!-- Email -->
            <el-col :span="4">
                <label>Email</label>
                <el-input
                  v-model="filters.email" 
                  size="small" 
                  placeholder="Filtrar pelo Email..."
                  @keyup.enter.native.prevent="fetch()"
                />
            </el-col>
  
            <!-- Centro de Distri -->
            <el-col :span="4">
              <label>Centro de Distribuição</label>
              <el-select
                  size="small"
                  v-model="filters.cd"
                  placeholder="Centro de distribuição"
                  :disabled="loading"
                  filterable 
              >
                <el-option label="Todos" value=""/>
                <el-option
                  v-for="center in centers"
                  :key="center.value"
                  :label="center.text"
                  :value="center.text"
                />
              </el-select>
            </el-col>
  
            <!-- Perfil do usuario -->
            <el-col :span="4">
              <label>Perfil do Usuário</label>
              <el-select
                size="small"
                v-model="filters.perfil"
                placeholder="Perfil do usuário"
                :disabled="loading"
                filterable 
              >
                <el-option label="Todos" value=""/>
                <el-option
                    v-for="role in roles"
                    :key="role.tipo"
                    :label="role.text"
                    :value="role.tipo"
                />
              </el-select>
            </el-col>
  
            <!-- Acoes -->
            <el-col :span="4">
              <el-button 
                size="small" 
                :disabled="loading" 
                @click="fetch()"
              >
                  <b-spinner small v-if="loading" variant="secondary" label="Spinning"></b-spinner>
                  <i v-else class="fas fa-search"></i>
                  Buscar
              </el-button>
            </el-col>
          </el-row>
  
          <el-row>
            <el-col>
              <div class="d-flex align-items-center justify-content-between">
                  <el-radio-group 
                    v-model="filters.status" 
                    size="mini"
                    :disabled="loading"
                    @change="fetch()"
                  >
                    <el-radio-button 
                        v-for="(stat) in [
                          { value: null, text: 'Todos' }, 
                          { value: 'Sim', text: 'Ativos' },
                          { value: 'Não', text: 'Inativos' }
                        ]"
                        :key="stat.text"
                        :label="stat.value"
                    >
                        <div class="d-flex align-items-center">
                            <!-- <el-tag 
                                :type="stat.text == 'Todos' 
                                    ? '' 
                                    : (stat.text == 'Sim' 
                                        ? 'success' 
                                        : (stat.text == 'Não' 
                                            ? 'warning' 
                                            : 'danger'
                                            )
                                        )"
                                size="mini" 
                                class="mr-1"
                            >
                                {{  filstatus == stat.value ? filtro.total : 0  }}
                            </el-tag> -->
                            <span class="ml-1">{{ stat.text }}</span>
                        </div>
                    </el-radio-button>
                  </el-radio-group>
              </div>
            </el-col>
          </el-row>
        </el-form>
  
        <!-- Tabela -->
        <div>
          <div v-if="loading" class="border rounded p-3 d-flex align-items-center">
            <i class="el-icon-loading mr-2"></i>
            Carregando usuários...
          </div>
  
          <!-- content -->                 
          <el-table
            v-else-if="!loading && users.length > 0"
            class="rounded"
            empty-text="Nenhum usuário encontrado." 
            v-loading="loading"
            :data="users" 
            align="center" 
            border
            row-key="id"
            size="mini"
          >   
            <!-- ID -->
            <el-table-column 
              label="ID" 
              width="80"
              prop="id" 
              align="left"
            >
              <div slot-scope="scope">{{ scope.row.id }}</div>
            </el-table-column>
  
            <!-- Nome -->
            <el-table-column min-width="320" label="Nome" align="left">
                <template slot-scope="scope">
                    <span>{{ scope.row.name }}</span>
                </template>
            </el-table-column>
  
            <!-- E-mail -->
            <el-table-column width="300" label="E-mail" align="left">
              <template slot-scope="scope">
                <span>{{ scope.row.email != null ? scope.row.email : '-' }}</span>
              </template>
            </el-table-column>
  
            <!-- Status -->
            <el-table-column label="Status" width="100" align="left">
                <template slot-scope="scope">
                    <el-tag 
                        v-if="scope.row.status != undefined"
                        size="small"
                        :type="scope.row.status == true
                            ? 'success' 
                            : 'danger'"
                    >
                      {{ scope.row.status == true ? 'ATIVO' : 'INATIVO' }}
                    </el-tag>
                </template>
            </el-table-column>
              
            <!-- Centro de dist -->
            <el-table-column width="120" label="Centro de Distr." align="left">
                <template slot-scope="scope">
                    <span v-if="scope.row.cd">{{ scope.row.cd.descricao }}</span>
                    <el-tag 
                      v-else
                      type="info" 
                      size="small"
                    >
                      Não Associado
                    </el-tag>
                </template>
            </el-table-column>
  
            <!-- Regioes -->
            <el-table-column width="240" label="Regiões" align="left">
                <template slot-scope="scope">
                  <el-popover
                    v-if="scope.row.regioes.length > 0"
                    placement="bottom-end"
                    trigger="hover"
                  > 
                    <div 
                      slot="reference"
                      class="d-flex flex-wrap"
                      :style="{ gap: '4px', maxWidth: 'fit-content' }"
                    >
                      <el-tag      
                        size="mini"
                        v-for="(reg) in scope.row.regioes.slice(0, 5)"
                        :key="reg.id"
                      >
                        {{ reg.uf }}
                      </el-tag>
  
                      <el-tag      
                        v-if="scope.row.regioes.length > 5"
                        type="success"
                        size="mini"
                      >
                        {{ `+${scope.row.regioes.slice(5).length}` }}
                      </el-tag>
                    </div>
  
                    <div 
                      class="d-flex flex-wrap"
                      :style="{ gap: '4px', maxWidth: '300px' }"
                    >
                      <el-tag      
                        size="mini"
                        v-for="(reg) in scope.row.regioes.slice(5)"
                        :key="reg.id"
                      >
                        {{ reg.uf }}
                      </el-tag>
                    </div>
                  </el-popover>
  
                    <el-tag 
                      v-else
                      type="info" 
                      size="small"
                    >
                      Sem região
                    </el-tag>
                </template>
            </el-table-column>
  
            <!-- Perfil -->
            <el-table-column width="200" label="Perfil" align="left">
                <template slot-scope="scope">
                  <div v-if="scope.row.roles.length > 0">
                    <span     
                      v-for="(role) in scope.row.roles"
                      :key="role.id"
                    >
                      {{ role.label }}
                    </span>
                  </div>
                    <el-tag 
                      v-else
                      type="info" 
                      size="small"
                    >
                      Não Associado
                    </el-tag>
                </template>
            </el-table-column>
  
            <!-- Criado em -->
            <el-table-column label="Criado em" width="110" align="center">
                <template slot-scope="scope">
                    <div class="d-flex align-items-center justify-content-center">
                        <i class="el-icon-time"></i>
                        <span class="ml-1">{{ formatDate(scope.row.created_at) }}</span>
                    </div>
                </template>
            </el-table-column>
  
            <!-- Atualizado em -->
            <el-table-column label="Última atualização" width="140" align="center">
                <template slot-scope="scope">
                      <div class="d-flex align-items-center justify-content-center">
                        <i class="el-icon-time"></i>
                        <span class="ml-1">{{ formatDate(scope.row.updated_at) }}</span>
                    </div>
                </template>
            </el-table-column>
  
            <!-- Acoes -->
            <el-table-column 
              fixed="right"
              :width="50"
              align="right"
            >
              <div slot="header" style="width: 100%;">
                  <i class="el-icon-menu" />
              </div>
              <template slot-scope="scope">
                <div class="d-flex justify-content-between">
                  <el-popover placement="bottom-end" trigger="hover">
                    <el-button
                      slot="reference"
                      size="mini" 
                      type="info" 
                      plain 
                      circle
                      :disabled="loading"
                    >
                      <i class="el-icon-more"></i>
                    </el-button>
  
                    <div :style="{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column', gap: '4px', maxWidth: '300px' }">
                      <div :style="{ width: '100%'}">
                        <el-button
                          size="mini" 
                          type="warning" 
                          plain 
                          :disabled="loading"
                          title="Editar usuário"
                          @click.native.prevent="$refs.userEditModal.getUser(scope.row.id)"
                          :style="{ width: '100%' }"
                        >
                          <i class="el-icon-edit"></i>
                          Editar Usuário
                        </el-button>
                      </div>
  
                      <div :style="{ width: '100%'}">
                        <el-button
                          v-if="isAuthorized && scope.row.status"
                          size="mini" 
                          type="success" 
                          plain
                          :disabled="loading"
                          title="Logar como"
                          @click.native.prevent="showLoginAs(scope.row.id)"
                          :style="{ width: '100%' }"
                        >
                          <i class="fas fa-sign-in-alt"></i>
                          Logar como
                        </el-button>
                      </div>
  
                      <div :style="{ width: '100%'}">
                        <el-button
                          size="mini"
                          type="primary" 
                          plain
                          :disabled="loading"
                          title="Editar senha usuário"
                          @click.native.prevent="$refs.userEditPasswordModal.handleEdit(scope.row.id)"
                          :style="{ width: '100%' }"
                        >
                          <i class="el-icon-key"></i>
                          Editar Senha
                        </el-button>
                      </div>
                    </div>
                  </el-popover>
                </div>
              </template>
            </el-table-column>
          </el-table>
  
          <el-empty v-else description="Nenhum usuário disponível"></el-empty>
        </div>
        
        <!-- Paginacao -->
        <el-row class="mt-3">
          <el-col>
            <el-pagination
              background
              :current-page.sync="filters.current_page"
              :page-sizes="[15, 50, 75, 100]"
              :page-size="filters.per_page"
              layout="total, sizes, prev, pager, next"
              :total="filters.total"
              @current-change="fetch"
            />
                              <!-- @size-change="handleSizeChange" -->
          </el-col>
        </el-row>
      </CardBase>
    </CardBase>

    <!-- New User -->
    <UserCreateModal ref="userCreateModal" />

    <!-- Edit User -->
    <UserEditModal ref="userEditModal" />

    <!-- Edit User Password -->
    <UserEditPasswordModal ref="userEditPasswordModal" />

    <!-- Delete User -->
    <!-- <DeleteUserModal ref="deleteUserModal" /> -->
  </div>
</template>

<script>
  // Components
  import 
  {
    Table,
    TableColumn,
    Message,
    Loading,
    Row,
    Col,
    Dialog,
    Button,
    Input,
    Switch,
    Option,
    Select,
    Pagination,
    Tag,
    Tooltip,
    Card,
    Empty,
    Notification,
    Skeleton,
    Form,
    FormItem,
    Tabs, 
    TabPane,
    RadioButton,
    RadioGroup,
    DatePicker,
    Dropdown,
    DropdownMenu, 
    DropdownItem,
    Popover,
    Badge
  } from "element-ui";
  
  
  import CardBase from "@/components/_macro/CardBase.vue";
  import MacroSubHeader from "@/components/_macro/MacroSubHeader.vue";

  import UserCreateModal from "./UserCreateModal.vue";
  import UserEditModal from "./UserEditModal.vue";
  import UserEditPasswordModal from "./UserEditPasswordModal.vue";
  import UserDeleteModal from "./UserDeleteModal.vue";

  import { formatDate } from "@/util/formatters"

  //Api
  import { UserApi } from "@/api/User/UserApi";
  import { CentroDistribuicaoApi } from "@/api/CentroDistribuicaoApi";

  const userApi = new UserApi();
  const centroDistApi = new CentroDistribuicaoApi();

  export default {
    data() {
      return {
        roles: [],
        loading: false,
        users: [],
        filters: {
          nome: "",
          email: "",
          status: null,
          perfil: "",
          cd: "",
          current_page: 1,
          per_page: 20,
          total: 0,
        },
        listaCargos: [
          "",
          "GERENTE NACIONAL",
          "GERENTE DIVISIONAL",
          "GERENTE DISTRITAL",
          "PROMOTORA",
        ],
        perfil: null,
        data: [],
        roles: [],
        centers: [],
      };
    },
    computed: {
      isAuthorized() {
        return this.$store.getters['user/isAnyRole'](['adm']);
      },
    },
    methods: {
      async fetch() {
        this.loading = true;

        await axios.get("/adm/users/list", { params: {
            page: this.filters.current_page,
            nome: this.filters.nome,
            email: this.filters.email,
            perfil: this.filters.perfil,
            cd: this.filters.cd,
            status: this.filters.status,
          }}
        ).then((response) => {
          this.filters.total = response.data.total;
          this.users = response.data.data;
        }).catch(function (error) {
          Notification.error({
            title: 'Erro',
            message: 'Não foi possível obter os usuários. Algo inesperado ocorreu!'
          });
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
      },
      /** Funções */
      async getRoles() {
        try {
          const res = await userApi.roles()

          this.roles = res.data;
        } catch (error) {
          Notification.error({
              title: 'Erro',
              message: 'Não foi possível obter as funções dos usuários!'
          });
        } finally {
          this.isLoading = false;
        }
      },
      /** Centros de distribuição */
      async getCenters() {
        try {
          const res = await centroDistApi.pluck()

          this.centers = res.data;
        } catch (error) {
          Notification.error({
            title: 'Erro',
            message: 'Não foi possível obter os centros de distribução!'
          });
        } finally {
          this.isLoading = false;
        }
      },
      regraGrupos() {
        window.location.href = "/adm/users/grupos";
      },
      showLoginAs(userId) {
        this.$confirm('Deseja realmente logar com este usuário?', 'Logar como usuário', {
            confirmButtonText: 'Sim',
            cancelButtonText: 'Cancelar',
        }).then(async () => {
            this.loading = true

            window.location.assign(`/adm/logarComo/${userId}`);
        }).finally(() => {
            this.loading = false
        })
      },
      clearForm() {
        this.nome = "";
        this.email = "";
        this.password = "";
        this.confirme_password = "";
        this.errors = [];
        this.status = true;
        this.regioes = [];
        this.cd = "";
        this.representante = null;
        this.edit = true;
      },
      formatDate,
    },
    created() {
      this.fetch();
      this.getRoles();
      this.getCenters();
    },
    components: {
      UserCreateModal,
      UserEditModal,
      UserEditPasswordModal,
      UserDeleteModal,
      CardBase,
      MacroSubHeader,
      [Message.name]: Message,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Loading.name]: Loading,
      [Row.name]: Row,
      [Col.name]: Col,
      [Dialog.name]: Dialog,
      [Button.name]: Button,
      [Switch.name]: Switch,
      [Option.name]: Option,
      [Select.name]: Select,
      [Input.name]: Input,
      [Pagination.name]: Pagination,
      [Tooltip.name]: Tooltip,
      [Tag.name]: Tag,
      [Card.name]: Card,
      [Empty.name]: Empty,
      [Notification.name]: Notification,
      [Skeleton.name]: Skeleton,
      [Form.name]: Form,
      [FormItem.name]: FormItem,
      [Tabs.name]: Tabs,
      [TabPane.name]: TabPane,
      [RadioButton.name]: RadioButton,
      [RadioGroup.name]: RadioGroup,
      [DatePicker.name]: DatePicker,
      [Dropdown.name]: Dropdown,
      [DropdownMenu.name]: DropdownMenu,
      [DropdownItem.name]: DropdownItem,
      [Popover.name]: Popover,
      [Badge.name]: Badge
    },
  };
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/User/Index.vue